import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { nanoid } from 'nanoid'
import { useTheme } from '@material-ui/core/styles'
import { Divider, Grid } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import store from '../../../redux/store'

import api from '../../../services/api'
import messagesApi from '../../../services/messages'
import { shouldUpdateIdleMsg, getTriggers } from '../../../utils/messages'
import ScrollContainer from 'react-indiana-drag-scroll'

import { Duration } from 'luxon'

import {
  getShortcuts as getApiShortcuts,
  setShortcuts,
  shortcutError,
} from '../../../redux/shortcuts/actions'

import {
  getFaq as getApiFaq,
  faqError,
  setFaq,
  setFile,
  setActiveSkillId,
} from '../../../redux/faq/actions'

import {
  getScript as getApiScript,
  scriptError,
  setScript,
} from '../../../redux/script/actions'

import { setFileDrop, setNewAgentMessage, setUpdateAgentMessage, setUpdateAgentMessageError, setUpdateAgentMessageSuccess, setUpdateConversation } from '../../../redux/conversations/actions'

import {
  HistoryRounded as HistoryIcon,
  SearchRounded as SearchIcon,
  ArrowForwardRounded as ForwardIcon,
  CancelPresentationRounded as CloseIcon,
  AttachmentRounded as AttachmentIcon,
  MoodRounded as MoodIcon,
  SendRounded as SendIcon,
  CloseRounded as CloseIcon2,
  DoneRounded as DoneIcon,
  ChatBubble as ChatIcon,
  KeyboardRounded as ShortcutIcon,
} from '@material-ui/icons'

import {
  setConversations,
  deleteConversations,
} from '../../../redux/conversations/actions'

import { setActiveConversation } from '../../../redux/activeConversation/actions'

import { updateGeneralInfo } from '../../../redux/generalInformation/actions'

import Tooltip from '../../atoms/display/tooltip'
import Typography from '../../atoms/display/typography'
import Conversation from './conversation'
import Clock from '../../atoms/display/clock'
import TextField from '../../atoms/inputs/textfield'
import Button from '../../atoms/inputs/button'
import Avatar from '../../molecules/avatar/customer'
import IconButton from '../../atoms/inputs/iconButton'
import Icon from '../../atoms/display/icon'
import Emojis from '../../molecules/display/emojis'
import ChatTransfer from '../../organisms/dialogs/chatTransfer'
import ChatClose from '../dialogs/chatClose'
import ChatSearch from '../../organisms/panels/chatSearch'
import Upload from '../../organisms/dialogs/upload'

import useStyles from './newChatStyle'
import TransferToSkillErroModel from '../dialogs/transferToSkillErroModel'

const NewChat = (props) => {
  const size = useSelector((state) => state.preferences)
  const expanded = useSelector((state) => state.expanded)

  const faq = useSelector((state) => state.faq)

  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  let useStylesParams = {
    size: size,
    expanded: expanded,
  }
  const classes = useStyles(useStylesParams)

  const theme = useTheme()
  const activeConversation = useSelector((state) => state.activeConversation)
  const conversation = useSelector(
    (state) => state.conversations.conversations[activeConversation]
  )
  const conversations = useSelector((state) => state.conversations)
  const messages = useSelector(
    (state) => state.conversations.messages[activeConversation]
  )
  const relatedComponents = conversation?.relatedComponents
  const generalInformation = useSelector(
    (satate) => satate.generalInformation.conversations
  )
  const user = useSelector((state) => state.user)
  const shortcuts = useSelector((state) => state.shortcuts)
  const faqs = useSelector((state) => state.faq)
  const script = useSelector((state) => state.script)
  const userPreferences = useSelector((state) => state.userPreferences)

  const [msgHotkey, setMsgHotkey] = useState(userPreferences?.data?.msgHotkey)
  const [formError, setFormError] = useState({})
  const [controls, setControls] = useState(true)
  const [knowledge, setKnowledge] = useState(false)
  const [knowledgeFiltered, setKnowledgeFiltered] = useState([])
  const [shortcut, setShortcut] = useState(false)
  const [shortcutFiltered, setShortcutFiltered] = useState([])
  const [chatTransferDialog, setChatTransferDialog] = useState(false)
  const [openCloseAlert, setOpenCloseAlert] = useState(false)
  const [bottomHeight, setBottomHeight] = useState(null)
  const [openSearch, setOpenSearch] = useState(false)
  const [openUpload, setOpenUpload] = useState(false)
  const [showEmojis, setShowEmojis] = useState(false)
  const [files, setFiles] = useState([])
  const [acceptFiles, setAcceptFiles] = useState('')
  const [soundRecorder, setSoundRecorder] = useState(false)
  const [recordingTime, setRecordingTime] = useState(0)
  const [audioFile, setAudioFile] = useState(null)
  const [inputMessage, setInputMessage] = useState(null)
  const mediaRecorder = useRef(null)
  const uploadedAudio = useRef({})
  const sendAudio = useRef(false)
  const chunks = useRef([])
  const totalAnchorsRef = useRef(0)
  const currentAnchorRef = useRef(0)
  const keyboardInputRef = useRef()
  const picker = useRef(null)
  const inputMessageRef = useRef()
  const footerRef = useRef(null)
  const recordingTimer = useRef(null)
  const testREF = useRef(null)

  const [messagesErros, setMessagesErrors] = useState([]);
  const [showModalErros, setShowModalErros] = useState(false);

  const handleClickCloseModalRequest = useCallback(()=>{
    setShowModalErros(false);
    setMessagesErrors([]);
  },[]);

  const handleClickOpenModalRequest = useCallback(()=>{
    setShowModalErros(true);    
  },[]);

  const onSetErrosMessages = useCallback((msg)=>{
    setMessagesErrors(msg);
    setShowModalErros(true);
  },[]);

  useEffect(() => {
    setBottomHeight(footerRef?.current?.clientHeight)
    const intervalId = setInterval(() => {
      setBottomHeight(footerRef?.current?.clientHeight)
    }, 300)
    return () => clearInterval(intervalId)
  }, [])

  useEffect(() => {
    if (inputMessageRef?.current)
      inputMessageRef.current.value = relatedComponents?.currentChat?.message

    checkKnowledgeShortcut()

    return () => {
      const msg = inputMessageRef?.current?.value ?? inputMessage

      if (relatedComponents?.currentChat)
        relatedComponents.currentChat.message = msg
    }
  }, [inputMessageRef, relatedComponents, inputMessage])  

  useEffect(() => {
    if (files.length > 0) {
      handleSubmit()
    }
  }, [files])

  // useEffect(() => {
  //   if (soundRecorder) {
  //     navigator.mediaDevices
  //       .getUserMedia({ audio: true })
  //       .then((stream) => {
  //         handleStream(stream)
  //         startRecording()
  //       })
  //       .catch(() => {
  //         enqueueSnackbar(t('toasts.microphoneNotAllowed'), {
  //           variant: 'error',
  //           onClose: () => {
  //             setSoundRecorder(false)
  //             setControls(true)
  //           },
  //         })
  //       })
  //   }
  //   return () => clearInterval(recordingTimer.current)
  // }, [soundRecorder])

  useEffect(async () => {
    if (sendAudio.current && audioFile) {
      const obj = {
        id: `audio`,
        file: audioFile,
        file_url: URL.createObjectURL(audioFile),
      }
      uploadedAudio.current.file_url = obj?.file_url
      uploadedAudio.current.mime_type = 'audio/ogg'

      await uploadFile(obj)

      // send message
      if (!uploadedAudio.current.status?.error) handleSubmit()
      else uploadedAudio.current = {}
    }
  }, [audioFile])

  const getFaq = useCallback(
    async (skillId = null) => {
      if (faqs?.cached.global.length && faqs?.status?.get_faq?.loading) return
      dispatch(getApiFaq(skillId))
      try {
        const response = await messagesApi.get(
          '/tech4h-messages/conversation/predefined-messages',
          {
            params: {
              skill_id: skillId,
            },
          }
        )
        if (response.status === 200) {
          dispatch(setFaq(skillId, response.data?.data))
        } else {
          throw response.data
        }
      } catch (error) {
        let message =
          error?.response?.status === 500
            ? 'Unavailable service'
            : error?.response?.data?.message
        if (skillId) {
          dispatch(
            faqError({ action: 'get_faq_by_skill', message: message, skillId })
          )
        } else {
          dispatch(faqError({ action: 'get_faq', message: message }))
        }
      }
    },
    [dispatch, faqs?.cached.global.length, faqs?.status?.get_faq?.loading]
  )

  const getShortcuts = async () => {
    dispatch(getApiShortcuts())
    try {
      const response = await api.get(`/flash-message`)
      if (response.status === 200) {
        dispatch(setShortcuts(response.data.data?.responseFlash))
      } else {
        throw response.data
      }
    } catch (error) {
      let message =
        error?.response?.status === 500
          ? 'Unavailable service'
          : error?.response?.data?.message
      dispatch(shortcutError({ action: 'get_shortcuts', message: message }))
    }
  }

  useEffect(() => {

    if (!shortcuts?.shortcuts) {
      getShortcuts()
    }
    supportedFilesAccept()
  }, [])

  useEffect(() => {
    function undockCommand() {
      const item = localStorage.getItem('undockCommand')
      if (item === 'updateShortcut') {
        getShortcuts()
        localStorage.removeItem('undockCommand')
      }
    }
    window.addEventListener('storage', undockCommand)
    return () => {
      window.removeEventListener('storage', undockCommand)
    }
  }, [])

  useEffect(() => {
    setMsgHotkey(userPreferences?.data?.msgHotkey)
  }, [userPreferences])

  const supportedFilesAccept = () => {
    let accept = ''
    if (conversation.supportedFiles?.audio) {
      conversation.supportedFiles?.audio?.ext.map((el) => {
        accept += `audio/${el}, `
      })
    }
    if (conversation.supportedFiles?.image) {
      conversation.supportedFiles?.image?.ext.map((el) => {
        accept += `image/${el}, `
      })
    }
    if (conversation.supportedFiles?.file) {
      conversation.supportedFiles?.file?.ext.map((el) => {
        accept += `application/${el}, `
      })
    }
    if (conversation.supportedFiles?.video) {
      conversation.supportedFiles?.video?.ext.map((el) => {
        accept += `video/${el}, `
      })
    }

    let acceptResult = accept.substring(0, accept.length - 2)
    setAcceptFiles(acceptResult)
  }

  const uploadFile = async (file) => {
    if (file) {
      try {
        const sendTime = new Date().getTime()
        const formData = new FormData()
        formData.append(file.id, file.file)

        const response = await messagesApi.post(
          `/channel/upload/file/${activeConversation}/${sendTime}/`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )

        if (response.status === 200) {
          uploadedAudio.current.fileId = response.data.data?.fileId
          uploadedAudio.current.status = { success: true }
        } else {
          throw response.data
        }
      } catch (error) {
        const message =
          error?.response?.status === 500
            ? 'Unavailable service'
            : error?.response?.data?.message[0]?.value
        console.error('[audio upload]', error)

        uploadedAudio.current.status = { error: true }
        enqueueSnackbar(t(message), {
          variant: 'error',
        })
      }
    }
  }

  const handleStream = (stream) => {
    window.streamReference = stream
    mediaRecorder.current = new MediaRecorder(stream)

    mediaRecorder.current.ondataavailable = (e) => {
      chunks.current.push(e.data)
      if (mediaRecorder.current.state === 'inactive') {
        let blob = new Blob(chunks.current, { type: 'audio/ogg; codecs=opus' })
        setAudioFile(blob)
      }
    }
  }

  const startRecording = () => {
    if (mediaRecorder.current) {
      chunks.current = []
      mediaRecorder.current.start()
      recordingTimer.current = setInterval(
        () => setRecordingTime((prev) => prev + 1),
        1000
      )
    }
  }

  const stopRecording = () => {
    clearInterval(recordingTimer.current)
    setRecordingTime(0)

    if (!window.streamReference) return
    window.streamReference.getAudioTracks().forEach((track) => track.stop())
    window.streamReference = null
  }

  const handleSubmit = () => {
    const msgs = []
    const initialStatus = {
      sending: false,
      sent: false,
      delivered: false,
      read: false,
      error: false,
    }

    if (uploadedAudio.current?.file_url) {
      msgs.push({
        fileId: uploadedAudio.current.fileId,
        file_url: uploadedAudio.current.file_url,
        mime_type: uploadedAudio.current.mime_type,
        sendTime: new Date(),
      })
    }

    // Add message when there's no file selected
    else if (files.length === 0) {
      if (inputMessageRef?.current?.value) {
        const inputMessageValue = inputMessageRef?.current?.value

        // Clean fields
        inputMessageRef.current.value = ''
        setShowEmojis(false)

        // Add message
        msgs.push({
          text: inputMessageValue,
          sendTime: new Date(),
        })
      }
    } else {
      // Add message for files uploaded successfully
      files
        .filter((msg) => msg.status?.success)
        .forEach((file) =>
          msgs.push({
            text: file.text,
            fileId: file.fileId,
            file_url: file.preview,
            sendTime: new Date(),
          })
        )
    }
        
    msgs.forEach((message) => {
      let msg = {
        _id: uuidv4(),
        by: 'agent',
        userId: null,
        currentId: null,
        previousId: null,
        sentTime: message.sendTime,
        receivedTime: null,
        text: message.text,
        files: {
          file_url: message?.file_url ?? null,
          mime_type: message?.mime_type ?? null,
        },
        favorite: null,
        private: false,
        systemMessage: false,
        status: { ...initialStatus, sending: true },
        unread: true,
      }

      let conversationData = {}
      if (shouldUpdateIdleMsg(conversation, msg)) {
        // Update idle message
        conversationData.idleMessage = msg
        conversationData.statusTriggers = getTriggers(conversation) ?? conversation?.statusTriggers
      }

      // Update last message attribute (chatItem)
      conversationData.lastMessage = msg

      dispatch(setNewAgentMessage({
        message: msg, 
        conversationData, 
        chatId: activeConversation
      }))

      const data = {
        date: message.sendTime.getTime(),
      }

      if (message.text) data.text = message.text
      if (message.fileId) data.fileId = message.fileId

      messagesApi({
        method: 'post',
        url: `/channel/response/send/${activeConversation}`,
        data,
      })
        .then((response) => {
          const data = response?.data?.data
          if (response.status === 200) {
            dispatch(setUpdateAgentMessageSuccess({
              chatId: activeConversation,
              message: msg,
              response: data
            }))
          }
        })
        .catch((error) => {
          console.error(error)
          dispatch(setUpdateAgentMessageError({
            chatId: activeConversation,
            message: msg,
          })) 
        });
    })

    // Clean list of sent files
    setFiles([])
  }

  const checkKnowledgeShortcut = () => {
    if (inputMessageRef?.current?.value?.substring(0, 1) === '/') {
      setShortcut(false)
      setKnowledge(true)
      let keyword = inputMessageRef?.current?.value.substring(1)
      setKnowledgeFiltered([])
      if (keyword) {
        faqs?.content
          ?.map((el) => {
            if (
              keyword &&
              (el.text.toLowerCase().includes(keyword.toLowerCase()) ||
                el.title.toLowerCase().includes(keyword.toLowerCase()))
            ) {
              setKnowledgeFiltered((knowledgeFiltered) => [
                ...knowledgeFiltered,
                {
                  title: el.title,
                  message: el.text,
                  file: el.files ? el.files : null,
                },
              ])
            }
          })
      } else {
        faqs?.content
          ?.map((el) => {
            setKnowledgeFiltered((knowledgeFiltered) => [
              ...knowledgeFiltered,
              {
                title: el.title,
                message: el.text,
                file: el.files ? el.files : null,
              },
            ])
          })
      }
    } else {
      setKnowledge(false)
    }
    if (inputMessageRef?.current?.value?.substring(0, 2) === '//') {
      setKnowledge(false)
      setShortcut(true)
      let keyword = inputMessageRef?.current?.value.substring(2)
      setShortcutFiltered([])
      if (keyword) {
        shortcuts?.shortcuts?.map((el) => {
          if (
            keyword &&
            (el.message.toLowerCase().includes(keyword.toLowerCase()) ||
              el.short_name.toLowerCase().includes(keyword.toLowerCase()))
          ) {
            setShortcutFiltered((shortcutFiltered) => [
              ...shortcutFiltered,
              {
                title: el.short_name,
                message: el.message,
              },
            ])
          }
        })
      } else {
        shortcuts?.shortcuts?.map((el) => {
          setShortcutFiltered((shortcutFiltered) => [
            ...shortcutFiltered,
            {
              title: el.short_name,
              message: el.message,
            },
          ])
        })
      }
    } else {
      setShortcut(false)
    }
  }

  const observeKeys = (e) => {
    checkKnowledgeShortcut()

    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      if (shortcut || knowledge) {
        keyboardInputRef.current.focus()
      }
    }
  }

  const handleHotkey = (e) => {
    if (e.key === 'Enter') {
      if (msgHotkey === 'Enter') {
        if (!e.ctrlKey && !e.shiftKey) {
          e.preventDefault()
          handleSubmit()
        }
      } else if (e.ctrlKey) {
        handleSubmit()
      }
    }
  }

  const renderKnowledge = () => {
    return (
      <>
        <div
          className={classes.knowledge}
          style={{ bottom: bottomHeight }}
          id="knowledge-container"
        >
          <div>
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Icon
                text={t('commons.messageSuggestions')}
                color={theme.palette.primary.secondary}
              >
                <ChatIcon style={{ color: theme.palette.primary.secondary }} />
              </Icon>
              <IconButton
                color="primary"
                onClick={() => {
                  setKnowledge(false)
                  inputMessageRef.current.value = ''
                }}
              >
                <CloseIcon2 style={{ color: theme.palette.primary.main }} />
              </IconButton>
            </div>
            <div style={{ height: 10 }} />
            <Divider />
            <div style={{ height: 15 }} />
            <HorizontalScroll className={classes.stage2}>
              <div className={classes.knowledgeSuggestions}>
                {knowledgeFiltered.length > 0 ? (
                  knowledgeFiltered.map((el) => {
                    return (
                      <div
                        className="knowledge-anchor"
                        style={{
                          display: 'flex',
                          padding: 10,
                          marginRight: 10,
                          minWidth: 300,
                          justifyContent: 'space-between',
                          cursor: 'pointer',
                          color: theme.palette.primary.main,
                          border: `1px solid ${theme.palette.primary.main}`,
                          fontSize: theme.typography.fontSize,
                          borderRadius: theme.shape.borderRadius,
                          '&:hover': {
                            backgroundColor: theme.palette.hover2,
                          },
                          wordBreak: 'break-all',
                        }}
                        key={nanoid()}
                        onClick={() => {
                          if (el.file) {
                            dispatch(
                              setFile({ files: el.file, message: el.message })
                            )
                          } else {
                            setKnowledge(false)
                            inputMessageRef.current.value = el.message
                          }
                        }}
                        data={el.message}
                      >
                        <div>
                          <Typography
                            variant="body2"
                            style={{
                              color: theme.palette.primary.main,
                              fontWeight: theme.typography.fontWeightBold,
                            }}
                          >
                            {el.title}
                          </Typography>
                          <Typography
                            variant="body2"
                            style={{
                              color: theme.palette.primary.main,
                            }}
                          >
                            {el.message.length > 244
                              ? el.message.substr(0, 245).trim().concat('...')
                              : el.message}
                          </Typography>
                        </div>
                        {el.file && (
                          <Typography>
                            <IconButton
                              color="primary"
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation()
                                window.open(el.file)
                              }}
                            >
                              <AttachmentIcon />
                            </IconButton>
                          </Typography>
                        )}
                      </div>
                    )
                  })
                ) : (
                  <Typography
                    variant="h6"
                    style={{ color: theme.palette.primary.secondary }}
                  >
                    {t('commons.noSuggestionsFound')}
                  </Typography>
                )}
              </div>
            </HorizontalScroll>
          </div>
        </div>
      </>
    )
  }

  const renderShortcut = () => {
    return (
      <>
        <div className={classes.knowledge} style={{ bottom: bottomHeight }}>
          <div>
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Icon
                text={t('commons.shortcuts')}
                color={theme.palette.primary.secondary}
              >
                <ShortcutIcon
                  style={{ color: theme.palette.primary.secondary }}
                />
              </Icon>
              <IconButton
                color="primary"
                onClick={() => {
                  setShortcut(false)
                  inputMessageRef.current.value = ''
                }}
              >
                <CloseIcon2 style={{ color: theme.palette.primary.main }} />
              </IconButton>
            </div>
            <div style={{ height: 10 }} />
            <Divider />
            <div style={{ height: 15 }} />
            <HorizontalScroll className={classes.stage2}>
              {shortcutFiltered.length > 0 ? (
                shortcutFiltered.map((el) => {
                  return (
                    <div
                      className="shortcut-anchor"
                      style={{
                        maxWidth: 200,
                        maxHeight: 'auto',
                        padding: 10,
                        marginRight: 10,
                        minWidth: 300,
                        cursor: 'pointer',
                        color: theme.palette.primary.main,
                        border: `1px solid ${theme.palette.primary.main}`,
                        fontSize: theme.typography.fontSize,
                        borderRadius: theme.shape.borderRadius,
                        '&:hover': {
                          backgroundColor: theme.palette.hover2,
                        },
                        wordBreak: 'break-all',
                      }}
                      key={nanoid()}
                      onClick={() => {
                        setShortcut(false)
                        inputMessageRef.current.value = el.message
                      }}
                      data={el.message}
                    >
                      <Typography
                        variant="body2"
                        style={{
                          color: theme.palette.primary.main,
                          fontWeight: theme.typography.fontWeightBold,
                        }}
                      >
                        {el.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        style={{ color: theme.palette.primary.main }}
                      >
                        {el.message}
                      </Typography>
                    </div>
                  )
                })
              ) : (
                <Typography
                  variant="body1"
                  style={{ color: theme.palette.primary.secondary }}
                >
                  {t('commons.noSuggestionsFound')}
                </Typography>
              )}
            </HorizontalScroll>
          </div>
        </div>
      </>
    )
  }

  const renderHeaderIcons = () => {
    return (
      <>
        {/* <Tooltip placement="bottom" title={t('tooltip.historic')}>
          <div>
            <IconButton
              active={props.showHistory}
              color="primary"
              onClick={() => props.setShowHistory()}
            >
              <HistoryIcon style={{ color: theme.palette.primary.main }} />
            </IconButton>
          </div>
        </Tooltip>
        <div style={{ width: 10 }} /> */}
        <Tooltip placement="bottom" title={t('tooltip.search')}>
          <div>
            <IconButton
              active={openSearch}
              color="primary"
              onClick={() => {
                setOpenSearch(openSearch ? false : true)
              }}
            >
              <SearchIcon style={{ color: theme.palette.primary.main }} />
            </IconButton>
          </div>
        </Tooltip>
        {conversation.status !== 'closed' &&
          conversation.status !== 'pos-chat' && (
            <>
              <div style={{ width: 10 }} />
              <Tooltip placement="bottom" title={t('tooltip.transfer')}>
                <div>
                  <IconButton
                    color="primary"
                    onClick={() => setChatTransferDialog(true)}
                  >
                    <ForwardIcon
                      style={{ color: theme.palette.primary.main }}
                    />
                  </IconButton>
                </div>
              </Tooltip>
              <div style={{ width: 10 }} />
              <Tooltip placement="bottom" title={t('tooltip.close')}>
                <div>
                  <IconButton
                    color="primary"
                    onClick={() => setOpenCloseAlert(true)}
                  >
                    <CloseIcon style={{ color: theme.palette.primary.main }} />
                  </IconButton>
                </div>
              </Tooltip>
            </>
          )}
      </>
    )
  }

  const renderHeader = () => {
    if (size === 'small') {
      return (
        <>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              flexWrap: 'nowrap',
            }}
          >
            <Clock              
              chatId={activeConversation}
              endTime={conversation?.end}
              assignedTime={conversation?.assignedTime}
            />
            <div style={{ width: 10 }} />
            {renderHeaderIcons()}
          </div>
        </>
      )
    } else {
      return (
        <>
          <Avatar
            src={''}
            name={conversation?.consumer?.name}
            variant={true}
            conversationId={conversation?.conversationId}
          />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              flexWrap: 'nowrap',
            }}
          >
            <Clock              
              chatId={activeConversation}
              endTime={conversation?.end}
              assignedTime={conversation?.assignedTime}
            />
            <div style={{ width: 10 }} />
            {renderHeaderIcons()}
          </div>
        </>
      )
    }
  }

  const renderSoundRecorder = () => {
    if (soundRecorder) {
      return (
        <>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ width: 10 }} />
            <input
              accept="image/*"
              id="icon-button-file"
              type="file"
              style={{ display: 'none' }}
            />
            <label htmlFor="icon-button-file">
              <IconButton color="primary" component="span">
                <AttachmentIcon style={{ color: theme.palette.primary.main }} />
              </IconButton>
            </label>
            <div style={{ width: 10 }} />
            <IconButton color="primary">
              <MoodIcon style={{ color: theme.palette.primary.main }} />
            </IconButton>
            <div style={{ width: 10 }} />
            <IconButton
              color="primary"
              onClick={() => {
                setSoundRecorder(false)
                setControls(true)
                stopRecording()
                sendAudio.current = false
              }}
            >
              <CloseIcon2 style={{ color: theme.palette.error.main }} />
            </IconButton>
            <div style={{ width: 10 }} />
            <div className={classes.recording} />
            <div style={{ width: 10 }} />
            <Typography variant={'subtitle1'}>
              {Duration.fromObject({
                seconds: recordingTime,
              }).toFormat('mm:ss')}
            </Typography>
            <div style={{ width: 10 }} />
            <IconButton
              color="primary"
              onClick={() => {
                setSoundRecorder(false)
                setControls(true)
                stopRecording()
                sendAudio.current = true
              }}
            >
              <DoneIcon style={{ color: theme.palette.success.main }} />
            </IconButton>
          </div>
        </>
      )
    }
  }

  const handleEmojiOnClick = (emoji, event) => {
    inputMessageRef.current.value =
      inputMessageRef.current.value + ' ' + emoji.native
  }

  const renderControls = () => {
    if (controls) {
      if (inputMessageRef?.current?.value.length > 222 && size !== 'small') {
        return (
          <>
            <div
              style={{
                marginLeft: 15,
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div style={{ marginBottom: 10 }}>
                <Button
                  size="large"
                  variant="contained"
                  fullWidth
                  color="primary"
                  endIcon={<SendIcon />}
                  onClick={handleSubmit}
                >
                  {t('buttons.send')}
                </Button>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ width: 10 }} />
                <IconButton
                  color="primary"
                  onClick={() => setOpenUpload(openUpload ? false : true)}
                >
                  <AttachmentIcon
                    style={{ color: theme.palette.primary.main }}
                  />
                </IconButton>
                <div style={{ width: 10 }} />
                {showEmojis && (
                  <Emojis open={setShowEmojis} onClick={handleEmojiOnClick} />
                )}
                <IconButton
                  color="primary"
                  ref={picker}
                  onClick={() => setShowEmojis(showEmojis ? false : true)}
                >
                  <MoodIcon style={{ color: theme.palette.primary.main }} />
                </IconButton>
                {
                  // TODO: uncomment block below when audio recording is allowed
                }
                {/* <div style={{ width: 10 }} />
                <IconButton
                  color="primary"
                  onClick={() => {
                    setSoundRecorder(true)
                    setControls(false)
                  }}
                >
                  <HeadsetIcon style={{ color: theme.palette.primary.main }} />
                </IconButton> */}
                <div style={{ width: 10 }} />
              </div>
            </div>
          </>
        )
      } else {
        return (
          <>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ width: 10 }} />
                <IconButton
                  color="primary"
                  onClick={() => setOpenUpload(openUpload ? false : true)}
                >
                  <AttachmentIcon
                    style={{ color: theme.palette.primary.main }}
                  />
                </IconButton>
                <div style={{ width: 10 }} />
                {showEmojis && (
                  <Emojis open={setShowEmojis} onClick={handleEmojiOnClick} />
                )}
                <IconButton
                  color="primary"
                  ref={picker}
                  onClick={() => setShowEmojis(showEmojis ? false : true)}
                >
                  <MoodIcon style={{ color: theme.palette.primary.main }} />
                </IconButton>

                {
                  // TODO: uncomment block below when audio recording is allowed
                }
                {/* <div style={{ width: 10 }} />
                <IconButton
                  color="primary"
                  onClick={() => {
                    setSoundRecorder(true)
                    setControls(false)
                  }}
                >
                  <HeadsetIcon style={{ color: theme.palette.primary.main }} />
                </IconButton> */}
                <div style={{ width: 10 }} />
              </div>
              <div>
                <Button
                  size="large"
                  variant="contained"
                  fullWidth
                  color="primary"
                  endIcon={<SendIcon />}
                  onClick={handleSubmit}
                >
                  {t('buttons.send')}
                </Button>
              </div>
            </div>
          </>
        )
      }
    }
  }

  const renderInput = () => {
    const placeholder =
      msgHotkey === 'Enter'
        ? t('commons.sendWithEnter')
        : t('commons.sendWithCtrlEnter')

    return (
      <TextField
        id={`field-message-${activeConversation}`}
        label={t('fields.message.label')}
        placeholder={`${t('fields.message.placeHolder')} (${placeholder})`}
        type="text"
        color="primary"
        variant="outlined"
        name="message"
        multiline={true}
        rowsMax={6}
        inputRef={inputMessageRef}
        onKeyDown={handleHotkey}
        onKeyUp={observeKeys}
        onBlur={() => setInputMessage(inputMessageRef?.current?.value ?? '')}
        error={!!formError?.message}
        helperText={
          formError?.message && t(`fields.message.errors.${formError.message}`)
        }
        shrink={true}
        fullWidth={true}
      />
    )
  }

  const renderFooter = () => {
    return size === 'small' ? (
      <>
        <div style={{ width: '100%' }}>
          <Grid spacing={3}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              {renderInput()}
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  flexWrap: 'nowrap',
                  marginTop: size === 'small' ? 15 : 0,
                }}
              >
                {renderControls()}
                {renderSoundRecorder()}
              </div>
            </Grid>
          </Grid>
        </div>
      </>
    ) : (
      <>
        {renderInput()}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-end',
            flexWrap: 'nowrap',
          }}
        >
          {renderControls()}
          {renderSoundRecorder()}
        </div>
      </>
    )
  }

  const navigateBetweenHelpers = (type, moviment, e) => {
    let x = document.getElementsByClassName(`${type}-anchor`)
    for (let i = 0; i < x.length; i++) {
      x[i].style.backgroundColor = `rgba(0,0,0,0)`
    }
    if (moviment === 'ArrowLeft') {
      currentAnchorRef.current =
        currentAnchorRef.current === 0
          ? (currentAnchorRef.current = x.length - 1)
          : currentAnchorRef.current - 1
    }
    if (moviment === 'ArrowRight') {
      currentAnchorRef.current =
        currentAnchorRef.current === x.length - 1
          ? (currentAnchorRef.current = 0)
          : currentAnchorRef.current + 1
    }
    if (moviment === 'Enter') {
      if (knowledgeFiltered[currentAnchorRef.current]?.file) {
        dispatch(
          setFile({
            files: knowledgeFiltered[currentAnchorRef.current]?.file,
            message: knowledgeFiltered[currentAnchorRef.current]?.message,
          })
        )
      } else {
        let text =
          x?.[currentAnchorRef.current]?.getElementsByTagName('p')[1]
            .textContent
        if (text) {
          inputMessageRef.current.value = text
          e.preventDefault()
          inputMessageRef.current.focus()
          currentAnchorRef.current = 0
          setKnowledge(false)
          setShortcut(false)
        }
      }
    }
    if (moviment === 'Escape') {
      inputMessageRef.current.value = ''
      e.preventDefault()
      inputMessageRef.current.focus()
      currentAnchorRef.current = 0
      setKnowledge(false)
      setShortcut(false)
    }
    if (x[currentAnchorRef.current]) {
      x[currentAnchorRef.current].style.backgroundColor = theme.palette.hover2
      x[currentAnchorRef.current].scrollIntoView()
    }
  }

  useEffect(() => {
    !faqs?.cached?.[conversation?.skillId] && getFaq(conversation?.skillId)

    dispatch(setActiveSkillId(conversation?.skillId))
  }, [conversation?.skill_id, faqs?.cached?.[conversation?.skillId]])

  return (
    <div id="dd" className={classes.container}>
      <div className={classes.root}>
        <div className={classes.header}>{renderHeader()}</div>
        {openSearch && (
          <ChatSearch open={openSearch} setOpenSearch={setOpenSearch} />
        )}
        <div>
          <audio ref={testREF}></audio>
        </div>
        <Conversation
          bottomHeight={bottomHeight}
        />
        {knowledge && renderKnowledge()}
        {shortcut && renderShortcut()}
        {conversation?.status !== 'closed' &&
          conversation?.status !== 'pos-chat' && (
            <div
              className={classes.footer}
              ref={footerRef}
              style={{
                alignItems:
                  bottomHeight > 135 && size !== 'small'
                    ? 'flex-start'
                    : 'center',
              }}
            >
              {renderFooter()}
            </div>
          )}
        {conversation?.status === 'closed' && (!conversation?.conversationTab || conversation?.pendingTab===true) && (
          <div
            className={classes.footerTab}
            ref={footerRef}
            style={{
              alignItems:
                bottomHeight > 135 && size !== 'small'
                  ? 'flex-start'
                  : 'center',
              width: '100%',
              justifyContent: 'space-between',
            }}
          >
            <Typography>
              {t('commons.closedConversationWithoutTabs')}
            </Typography>
            <Button
              size="large"
              variant="contained"
              color={'primary'}
              style={{ borderRadius: '20px' }}
              onClick={() => setOpenCloseAlert({ tabulation: true })}
            >
              {t('buttons.tabConversation')}
            </Button>
          </div>
        )}
      </div>
      <input
        type="text"
        ref={keyboardInputRef}
        onKeyUp={(e) => {
          if (knowledge || shortcut) {
            if (knowledge) {
              navigateBetweenHelpers('knowledge', e.key, e)
            }
            if (shortcut) {
              navigateBetweenHelpers('shortcut', e.key, e)
            }
          }
        }}
        style={{
          position: 'absolute',
          top: 0,
          height: 0,
          width: 0,
          opacity: 0,
        }}
      />

      <TransferToSkillErroModel
        title={t(`alerts.TransferUnavailable`)}
        msg={messagesErros}        
        isOpen={showModalErros}
        handleClickCloseModalRequest={handleClickCloseModalRequest}        
      />

      {chatTransferDialog && (
        <ChatTransfer
          open={chatTransferDialog}
          setOpen={setChatTransferDialog}
          chatId={activeConversation}
          onSetErrosMessages={onSetErrosMessages}
          onSubmit={(e) => {
            if (e?.status?.success) {
              // update store
              if (conversation) {
                dispatch(deleteConversations(activeConversation))
                dispatch(setActiveConversation(null))
              }
            }
          }}
        />
      )}
      {(openUpload || faq?.file || !!conversations?.files?.length) && (
        <Upload
          supportedFiles={conversation.supportedFiles}
          acceptFiles={acceptFiles}
          predefinedFile={faq?.file}
          predefinedFileDrop={conversations?.files}
          open={openUpload || faq?.file || conversations?.files?.length}
          setOpen={(e) => {
            setOpenUpload(e)
            dispatch(setFile(null))
            dispatch(setFileDrop([]))
          }}
          chatId={activeConversation}
          onSubmit={(updatedFiles) => {
            setFiles(updatedFiles)
            dispatch(setFile(null))
            dispatch(setFileDrop([]))
          }}
        />
      )}
      {openCloseAlert && (
        <ChatClose
          open={openCloseAlert}
          setOpen={setOpenCloseAlert}
          onSubmit={(e) => {
            if (e?.status?.success && e?.status?.status) {
              const generalInfo = generalInformation[activeConversation]
              let end = new Date();
              let assignedTime = null;              

              if(e?.conversationTA?.endConversation){
                end = new Date(`${e?.conversationTA?.endConversation}`);
              }

              if(e?.conversationTA?.startConversation){
                assignedTime = new Date(`${e?.conversationTA?.startConversation}`);
              }

              // Update conversation attributes
              if (conversation) {
                conversation.status = e?.status?.status
                conversation.end = end
                conversation.assignedTime = assignedTime ? assignedTime : conversation.assignedTime;
                dispatch(setConversations(conversation))
                dispatch(setActiveConversation(null))
              }

              // Update general information attributes
              if (generalInfo) {
                generalInfo.chatInfo.status = e?.status?.status
                generalInfo.chatInfo.end = end
                generalInfo.chatInfo.closedBy = user.name

                const obj = {
                  chatId: activeConversation,
                  data: generalInfo,
                }
                dispatch(updateGeneralInfo(obj))
              }
            }
          }}
        />
      )}
    </div>
  )
}

export default React.memo(NewChat)

const HorizontalScroll = ({ children, ...props }) => {
  const containerRef = useRef()
  useEffect(() => {
    const el = containerRef.current
    if (el) {
      const onWheel = (e) => {
        if (e.deltaY == 0) return
        e.preventDefault()
        el.scrollTo({
          left: el.scrollLeft + e.deltaY * 7,
          behavior: 'smooth',
        })
      }
      el.addEventListener('wheel', onWheel)
      return () => el.removeEventListener('wheel', onWheel)
    }
  }, [containerRef])
  return (
    <ScrollContainer
      vertical={false}
      horizontal={true}
      ignoreElements="input, textarea, span.escapeDragScroll"
      hideScrollbars={false}
      innerRef={containerRef}
      {...props}
    >
      {children}
    </ScrollContainer>
  )
}
